/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { OrganizationsControllerUpdateMutationRequest, OrganizationsControllerUpdateMutationResponse, OrganizationsControllerUpdatePathParams, OrganizationsControllerUpdate400, OrganizationsControllerUpdate401, OrganizationsControllerUpdate403, OrganizationsControllerUpdate404 } from "../../models/organizationsController/OrganizationsControllerUpdate";

function getOrganizationsControllerUpdateUrl(id: OrganizationsControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/organizations/${id}` as const }  
  return res
}

/**
 * @summary Update an organization
 * {@link /api/v1/organizations/:id}
 */
export async function organizationsControllerUpdate(id: OrganizationsControllerUpdatePathParams["id"], data?: OrganizationsControllerUpdateMutationRequest, config: Partial<RequestConfig<OrganizationsControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<OrganizationsControllerUpdateMutationResponse, ResponseErrorConfig<OrganizationsControllerUpdate400 | OrganizationsControllerUpdate401 | OrganizationsControllerUpdate403 | OrganizationsControllerUpdate404>, OrganizationsControllerUpdateMutationRequest>({ method : "PATCH", url : getOrganizationsControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}